import classnames from 'classnames';
import { upperFirst, camelCase, isFunction } from 'lodash';

var styles = {"alignLeft":"tJqeP","textWrapNowrap":"UvQLr","alignRight":"x2uN-","alignCenter":"YR1Fr","sizeFullWidth":"THbeK","renderedInTable":"HCiEI","sizeOriginal":"P2p-F","sizeContent":"gdvy8","sizeSmall":"TQxwO","sizeSmallCenter":"_8sRcD","flex":"eGLyr","atomic":"exAdT","anchor":"_0QOqx","embed":"UccVv","horizontalScrollbar":"_4Ad7J","pluginContainerMobile":"OobMR"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData, theme) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return classnames(styles[key], theme[key]);
};
const getSizeClassName = (containerData, theme) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return classnames(styles[key], theme[key]);
};
const getTextWrapClassName = (containerData, theme) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  const key = "textWrapNowrap";
  return classnames(styles[key], theme[key]);
};
const alignmentClassName = (node, theme) => {
  return getAlignmentClassName(getContainerData(node) || {}, theme);
};
const sizeClassName = (node, theme) => {
  return getSizeClassName(getContainerData(node) || {}, theme);
};
const textWrapClassName = (node, theme) => {
  return getTextWrapClassName(getContainerData(node) || {}, theme);
};
const getContainerClassNames = (node, draftComponentData, theme, isMobile, classNameStrategies, withHorizontalScroll) => {
  var _a;
  const { alignment, size, textWrap, custom } = classNameStrategies || {};
  const dataProperty = `${camelCase(node.type)}Data`;
  const hasLink = (_a = node[dataProperty]) == null ? void 0 : _a.link;
  return classnames(
    styles.pluginContainerReadOnly,
    {
      [styles.pluginContainerMobile]: isMobile,
      [styles.anchor]: hasLink,
      [styles.horizontalScrollbar]: withHorizontalScroll
    },
    isFunction(alignment) ? alignment(draftComponentData, theme, styles, isMobile) : alignmentClassName(node, theme),
    isFunction(size) ? size(draftComponentData, theme, styles, isMobile) : sizeClassName(node, theme),
    isFunction(textWrap) ? textWrap(draftComponentData, theme, styles, isMobile) : textWrapClassName(node, theme),
    isFunction(custom) ? custom(draftComponentData, theme, styles, isMobile) : null
  );
};

export { getAlignmentClassName as a, getSizeClassName as b, getTextWrapClassName as c, alignmentClassName as d, sizeClassName as e, getContainerClassNames as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-a74ecd7f.js.map
